import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import Layout from 'Layout';
import NonAuthLayout from "Layout/NonLayout"
import AuthProtected from './AuthProtected';
import SettingsLayout from 'pages/Settings/Layout';
import Integrations from 'pages/Settings/Integrations';
import WorkingHour from 'pages/Settings/WorkingHour';
import General from 'pages/Settings/General';

const RouteIndex = () => {
  return (
    <React.Fragment>
      <Routes>
        {authProtectedRoutes.filter(route => !route.path.startsWith('/setting/')).map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}

        {/* Settings nested routes */}
        <Route
          path="/setting"
          element={
            <AuthProtected>
              <Layout>
                <SettingsLayout />
              </Layout>
            </AuthProtected>
          }
        >
          <Route index element={<Integrations />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="working-hour" element={<WorkingHour />} />
          <Route path="general" element={<General />} />
        </Route>

        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            } />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
